import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/ocnc/app/components/auth-debug.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/ocnc/app/components/ChatwootWidget.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/ocnc/app/components/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/ocnc/app/components/sub-menu.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/ocnc/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/ocnc/app/providers/AuthProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CompetitionProvider"] */ "/vercel/path0/apps/ocnc/app/providers/CompetitionContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/vercel/path0/node_modules/.pnpm/@vercel+analytics@1.4.1_next@15.2.8_react-dom@19.0.1_react@19.0.1__react@19.0.1__react@19.0.1/node_modules/@vercel/analytics/dist/next/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/.pnpm/next@15.2.8_@babel+core@7.26.0_react-dom@19.0.1_react@19.0.1__react@19.0.1/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.2.8_@babel+core@7.26.0_react-dom@19.0.1_react@19.0.1__react@19.0.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.2.8_@babel+core@7.26.0_react-dom@19.0.1_react@19.0.1__react@19.0.1/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["ToastContainer","Bounce"] */ "/vercel/path0/node_modules/.pnpm/react-toastify@11.0.3_react-dom@19.0.1_react@19.0.1__react@19.0.1/node_modules/react-toastify/dist/index.mjs");
